/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

const productsOptions = [
  {
    label: (
      <>
        <p>
          <b>CNAB_240 (Cobrança)</b>
        </p>
      </>
    ),
    value: `CNAB_240`,
  },
  {
    label: (
      <>
        <p>
          <b>CNAB_400 (Cobrança)</b>
        </p>
      </>
    ),
    value: `CNAB_400`,
  },
  {
    label: (
      <>
        <p>
          <b>PDF (Cobrança)</b>
        </p>
      </>
    ),
    value: `PDF`,
  },
  {
    label: (
      <>
        <p>
          <b>CNAB_PDF (Cobrança)</b>
        </p>
      </>
    ),
    value: `CNAB_PDF`,
  },
  {
    label: (
      <>
        <p>
          <b>GENERICO</b>
        </p>
      </>
    ),
    value: `GENERICO`,
  },

  //

  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_A (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_A`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_J (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_J`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_GPS (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_GPS`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_DARF (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_DARF`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_DARF_SIMPLES (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_DARF_SIMPLES`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_GARE_SP (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_GARE_SP`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_IPVA (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_IPVA`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_IPTU (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_IPTU`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_DPVAT (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_DPVAT`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_LICENCIAMENTO (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_LICENCIAMENTO`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_N_DARJ (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_N_DARJ`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_O (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_O`,
  },
  {
    label: (
      <>
        <p>
          <b>PAGAMENTO_SEGMENTO_D (Pagamentos)</b>
        </p>
      </>
    ),
    value: `PAGAMENTO_SEGMENTO_D`,
  },
  {
    label: (
      <>
        <p>
          <b>CONVENIO_MODELO_V4</b>
        </p>
      </>
    ),
    value: `CONVENIO_MODELO_V4`,
  },
  {
    label: (
      <>
        <p>
          <b>CONVENIO_MODELO_V5</b>
        </p>
      </>
    ),
    value: `CONVENIO_MODELO_V5`,
  },
  {
    label: (
      <>
        <p>
          <b>CONVENIO_MODELO_V8</b>
        </p>
      </>
    ),
    value: `CONVENIO_MODELO_V8`,
  },
];

export default productsOptions;
